export const redirectTo = url => {
  globalThis.location.href = url;
};

export const redirectWithParamReplacement = (paramName, paramValue) => {
  const url = new URL(location.href);
  const searchParams = url.searchParams;
  searchParams.set(paramName, paramValue);
  url.search = searchParams.toString();
  location.href = url.toString();
};

export default redirectTo;
